/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userActions, examAssignmentActions } from '../../redux/actions';
import { pathConstants } from '../../constants';
import { AppDispatch, RootState } from '../../store';
import StudentProfileSection from './StudentProfileSection';
import AssignedExamsSection from './AssignedExamsSection';
import CompletedExamsSection from './CompletedExamsSection';
import WrongQuestionsStats from './WrongQuestionsStats';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, rgba(0, 150, 255, 0.4) 0%, rgba(100, 200, 255, 0.3) 100%);
  padding: 0;
`;

const PageContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

const LogoutButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(90deg, #ff6b6b 0%, #ff5252 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 14px;
  }
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const FullWidthSection = styled.div`
  &:nth-of-type(n + 2) {
    margin-top: 24px;
  }
`;


const StudentPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isUserLoggedIn = useAppSelector((state: any) => state.authentication.loggedIn);
  const currentUser = useAppSelector((state: any) => state.authentication.userInfo);
  const { studentExams, loading: assignLoading } = useSelector((state: RootState) => state.examAssignments);
  const [completedExams, setCompletedExams] = useState<any[]>([]);

  console.log('StudentPage render - currentUser:', currentUser);
  console.log('StudentPage render - currentUser.userName:', currentUser?.userName);
  console.log('StudentPage render - studentExams:', studentExams);

  useEffect(() => {
    if (!isUserLoggedIn) {
      navigate(pathConstants.ROOT);
      return;
    }

    // Fetch student's assigned exams using user.id (not student_id)
    if (currentUser?.id) {
      console.log('StudentPage useEffect - fetching exams for user:', currentUser.id);
      dispatch(examAssignmentActions.getStudentAssignedExams(currentUser.id));
    }
  }, [currentUser, isUserLoggedIn, navigate, dispatch]);

  const onLogout = () => {
    dispatch(userActions.logout());
    navigate(pathConstants.ROOT);
  };

  const handleCompletedExamsLoaded = (exams: any[]) => {
    setCompletedExams(exams);
  };

  return (
    <PageContainer>
      <PageContent>
        <TopSection>
          {/* Profile + review card (between profile & vocab stats) + vocab stats — all inside ProfileSection */}
          <StudentProfileSection
            currentUser={currentUser}
            onLogout={onLogout}
            onReviewClick={() => navigate('/student/reviews')}
          />

          {/* Thống kê bài tập */}
          <WrongQuestionsStats userId={currentUser?.id} />
        </TopSection>

        <FullWidthSection>
          <AssignedExamsSection 
            userId={currentUser?.id}
            assignedExams={studentExams}
            completedExams={completedExams}
            loading={assignLoading}
          />
        </FullWidthSection>

        <FullWidthSection>
          <CompletedExamsSection userId={currentUser?.id} onExamsLoaded={handleCompletedExamsLoaded} />
        </FullWidthSection>
      </PageContent>
    </PageContainer>
  );
};

export default StudentPage;
